import React from "react";
import { Check } from "lucide-react";
import { useCurrency } from "../contexts/CurrencyContext";
import { CURRENCY_META } from "../lib/currency";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function CurrencySwitcher({ compact = false }) {
  const { currency, supported, setCurrency, meta } = useCurrency();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="currency-switcher-trigger"
        className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 bg-white/70
                   backdrop-blur px-3 py-2 text-xs font-semibold uppercase tracking-[0.14em]
                   text-ink/80 hover:text-ink hover:border-ink/40 transition-colors"
        aria-label="Currency"
      >
        <span className="text-base leading-none" aria-hidden="true">{meta.symbol}</span>
        {!compact && (
          <span data-testid="current-currency" className="hidden sm:inline">{currency}</span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[170px]">
        {supported.map((c) => {
          const m = CURRENCY_META[c];
          return (
            <DropdownMenuItem
              key={c}
              data-testid={`currency-option-${c}`}
              onClick={() => setCurrency(c)}
              className="flex items-center justify-between cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <span className="text-base w-5 text-ink/80">{m.symbol}</span>
                <span className="text-sm">{c}</span>
                <span className="text-xs text-ink/50">· {m.label}</span>
              </span>
              {c === currency ? <Check className="h-4 w-4 text-brand-pink" /> : null}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
